import format from 'date-fns/format';
import ru from 'date-fns/locale/ru';
import type React from 'react';

import * as st from './styles.module.scss';

type Props = {
	date: Date;
	showCalendar: boolean;
};

export const SelectedDate: React.FC<Props> = ({ date, showCalendar }) => {
	const formattedDate = format(date, showCalendar ? 'LLLL yyyy' : `EEEEEE, dd MMMM yyyy`, {
		locale: ru,
	});
	const currentDate = formattedDate[0].charAt(0).toUpperCase() + formattedDate.slice(1);

	return (
		<div className={st.date}>
			{currentDate}
			{/* {format(date, showCalendar ? 'LLLL yyyy' : `EEEEEE, dd MMMM yyyy`, { locale: ru })} */}
		</div>
	);
};
